/* eslint-disable jsx-a11y/label-has-associated-control */
import { Field, useField } from "formik";
import React, { ReactNode, useState } from "react";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import * as styles from "../CheckBoxField/CheckBoxField.module.css";
import * as commonStyles from "../commonStyles/commonStyles.module.css";
import { FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { FormattedText } from "../FormattedText";
import { useSetFieldTouched } from "../useSetFieldTouched";

export type CheckBoxOptionEnablerProps = Readonly<{
  text: string;
  children: ReactNode;
  name: string;
  isBusinessContactCustomerCheck?: boolean;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const CheckBoxOptionEnabler = (props: CheckBoxOptionEnablerProps) => {
  const { text, children, name, disabled, isSaving, isBusinessContactCustomerCheck } = props;
  const [field, _meta, _helpers] = useField(props);
  const [checkBoxEnabled, setCheckBoxEnabled] = useState(field.value);
  useSetFieldTouched(field.name);

  const renderChildren = () => {
    if (isBusinessContactCustomerCheck && !checkBoxEnabled) {
      return children;
    } else if (!isBusinessContactCustomerCheck && checkBoxEnabled) {
      return children;
    } else {
      return null;
    }
  };

  return (
    <Row className={commonStyles.internalContainer}>
      <Column>
        <div className={styles.optionMargin}>
          <label key={`checkbox-option`} className={styles.option}>
            <Field
              type="checkbox"
              name={name}
              data-testid={name}
              disabled={disabled || isSaving}
              onClick={() => setCheckBoxEnabled(!checkBoxEnabled)}
            />
            <FormattedText text={text} />
          </label>
        </div>
        {renderChildren()}
      </Column>
    </Row>
  );
};
